/* eslint-disable @typescript-eslint/no-explicit-any */
import { graphql } from "../generated"

export const PrepareXmlFileForB2G = graphql(`
  mutation PrepareXmlFileForB2G($input: PrepareXmlFileForB2GInput!) {
    prepareXmlFileForB2G(input: $input) {
      b2gPayload
      errorMessages
      fileName
      requestType
      responseId
      status
      xmlInputId
    }
  }
`)

export const ProcessB2GIntegration = graphql(`
  mutation ProcessB2GIntegration($input: ProcessB2GIntegrationInput!) {
    processB2GIntegration(input: $input) {
      errorMessages
      fileName
      requestType
      responseId
      status
      xmlInputId
    }
  }
`)

export const addOrUpdateWineProduct = graphql(`
  mutation addOrUpdateWineProduct($product: B2GProductInput!) {
    addProduct(product: $product, ingredients: []) {
      id
      commodity
      modifiable
      description
      premise {
        id
      }
    }
  }
`)

export const newReferencedDocumentMutation = graphql(`
  mutation newReferencedDocument($filename: String = "") {
    newReferencedDocument(filename: $filename) {
      id
      url
    }
  }
`)

export const deleteReferencedDocumentMutation = graphql(`
  mutation deleteSupportingDocument($id: ID!) {
    deleteReferencedDocument(id: $id)
  }
`)

export const newCoreReferencedDocumentMutation = graphql(`
  mutation newCoreReferencedDocument($input: NewCoreReferencedDocumentInput!) {
    newCoreReferencedDocument(input: $input) {
      id
      url
    }
  }
`)

export const deleteCoreReferencedDocumentMutation = graphql(`
  mutation deleteCoreReferencedDocument($id: ID!) {
    deleteCoreReferencedDocument(id: $id)
  }
`)

export const CreateNewTypesenseApiKey = graphql(`
  mutation newApiKey {
    newSearchApiKey {
      apiKey
      expires
    }
  }
`)

export const acceptedTermsAndConditions = graphql(`
  mutation acceptedTermsAndConditions {
    acceptedTermsAndConditions
  }
`)

export const CreatePartyTypesenseApiKey = graphql(`
  mutation newPartyApiKey {
    newPartyApiKey {
      apiKey
      expires
    }
  }
`)

export const CreateMultiCollectionApiKeys = graphql(`
  mutation newMultiCollectionApiKeys {
    newMultiCollectionApiKeys {
      products
      exportCertificates
      exporters
      transferRequests
      agency
      registration
      registrationAll
      expires
      partyApiKey
    }
  }
`)

export const CreateMultiCollectionApiKeysV2 = graphql(`
  mutation GetApiKeysV2 {
    newMultiCollectionApiKeysV2 {
      exports {
        supportingDocuments
        exportCertificates
        registration
        registrationAll
        transferRequests
        sourceTransfers
      }
      transfers {
        supportingDocuments
        exportCertificates
        registration
        registrationAll
        transferRequests
        sourceTransfers
      }
      supportingDocs {
        registration
        registrationAll
        supportingDocuments
      }
      products
      partyApiKey
      agency
      expires
      exporters
    }
  }
`)

export const mutateDraftExportCertificateRequest = graphql(`
  mutation mutateDraftExportCertificateRequest(
    $id: ID
    $referencedDocuments: [B2GReferencedDocumentInput!]
    $exporterDeclaration: B2GExporterDeclarationInput
    $destination: B2GCountryInput
    $consignment: B2GConsignmentInput
    $commodity: String = ""
    $certificateType: CertificateType
    $certificateDelivery: B2GCertificateDeliveryInput
    $requestName: String = ""
    $requestedOnBehalfOfConsignor: Boolean
    $copyFromId: String
  ) {
    draftExportCertificateRequest(
      request: {
        id: $id
        referencedDocuments: $referencedDocuments
        exporterDeclaration: $exporterDeclaration
        destination: $destination
        consignment: $consignment
        commodity: $commodity
        certificateType: $certificateType
        certificateDelivery: $certificateDelivery
        requestName: $requestName
        requestedOnBehalfOfConsignor: $requestedOnBehalfOfConsignor
        copyFromId: $copyFromId
      }
    ) {
      id
      destination {
        id
      }
      commodity
      certificateType
      market
    }
  }
`)

export const mutateRaiseExportCertificateRequest = graphql(`
  mutation mutateRaiseExportCertificateRequest($id: ID!) {
    raiseExportCertificateRequest(id: $id) {
      id
      status
      statusLabel
    }
  }
`)

export const mutateDeleteExportRequest = graphql(`
  mutation discardExportCertificateRequest($id: ID!) {
    discardExportCertificateRequest(id: $id)
  }
`)

export const mutateDeleteExportRequestById = graphql(`
  mutation deleteExportRequestById($id: ID!) {
    deleteExportRequestById(id: $id)
  }
`)

export const mutateDeleteTransferRequestById = graphql(`
  mutation deleteTransferRequestById($id: ID!) {
    deleteTransferRequestById(id: $id)
  }
`)

export const mutateCancelExportCertificateRequest = graphql(`
  mutation cancelExportCertificateRequest(
    $input: CancelExportCertificateRequestInput!
  ) {
    cancelExportCertificateRequest(input: $input) {
      id
    }
  }
`)

export const mutationCompleteSensoryProcess = graphql(`
  mutation CreateSensoryProcess(
    $productId: ID!
    $reference: String!
    $disputed: Boolean!
    $disputedReason: WineDisputedReason
    $comment: String
    $winemaker: String!
    $assessmentDate: AWSDateTime!
  ) {
    completeSensoryProcess(
      input: {
        productId: $productId
        reference: $reference
        disputed: $disputed
        disputedReason: $disputedReason
        comment: $comment
        winemaker: { personName: $winemaker }
        assessmentDate: $assessmentDate
      }
    ) {
      id
      productId
      reference
      disputed
      disputedReason
      comment
      winemaker {
        personName
      }
      assessmentDate
    }
  }
`)

export const mutateRequestChemistryTest = graphql(`
  mutation RequestChemistryTest(
    $productId: ID!
    $expectedAlcoholContent: Float
    $laboratory: String!
    $packagingReference: String
    $packagingDate: AWSDateTime
    $sampleCollectionDate: AWSDateTime!
    $testRequired: ID!
  ) {
    requestChemistryTest(
      input: {
        productId: $productId
        attributes: {
          expectedAlcoholContent: $expectedAlcoholContent
          laboratory: $laboratory
          packagingReference: $packagingReference
          packagingDate: $packagingDate
          sampleCollectionDate: $sampleCollectionDate
          testRequired: $testRequired
        }
      }
    ) {
      status
      cancelledReason
      firstResultReportedDate
      receipt {
        laboratoryReference
        receiptDate
        sampleSuitable
        unsuitableReason
      }
      request {
        expectedAlcoholContent
        laboratory
        packagingDate
        packagingReference
        sampleCollectionDate
        testRequired
        sampleReference
        wineTestReference
      }
    }
  }
`)

export const mutationAddBottlingRuns = graphql(`
  mutation AddBottlingRuns($input: BottlingRunInput!) {
    addBottlingRuns(input: $input) {
      processId
      runs {
        id
        bottleVolume
        bottlesPerCase
        cases
        date
        extraBottles
        reference
      }
    }
  }
`)

export const mutationAddFlexiFillingRuns = graphql(`
  mutation AddFlexiFillingRuns($input: FlexiFillingRunInput!) {
    addFlexiFillingRuns(input: $input) {
      processId
      runs {
        date
        litres
        id
        reference
      }
    }
  }
`)

export const mutationStartPackaging = graphql(`
  mutation StartPackaging($productId: ID!) {
    startPackaging(productId: $productId) {
      id
      type
      task {
        taskId
        assignedTo
      }
    }
  }
`)

export const mutationRequestConfirmation = graphql(`
  mutation RequestConfirmation($input: RequestConfirmationInput!) {
    requestConfirmation(input: $input) {
      wsmp
      processId
    }
  }
`)

export const mutationConfirmPackaging = graphql(`
  mutation ConfirmPackaging($input: ConfirmPackagingInput!) {
    confirmPackaging(input: $input) {
      confirmed
      disputeReason
      disputeResolution
      processId
    }
  }
`)

export const mutationCancelProcess = graphql(`
  mutation CancelProcess($processId: ID!, $cancelledReason: String) {
    cancelProcess(
      input: { processId: $processId, cancelledReason: $cancelledReason }
    ) {
      status
      cancelledReason
      firstResultReportedDate
      receipt {
        laboratoryReference
        receiptDate
        sampleSuitable
        unsuitableReason
      }
      request {
        expectedAlcoholContent
        laboratory
        packagingDate
        packagingReference
        sampleCollectionDate
        testRequired
        sampleReference
        wineTestReference
      }
    }
  }
`)

export const mutationStartWinemaking = graphql(`
  mutation StartWinemaking($productId: ID!) {
    startWinemaking(productId: $productId) {
      type
      task {
        assignedTo
        taskId
      }
      id
    }
  }
`)

export const mutationConfirmWinemaking = graphql(`
  mutation ConfirmWinemaking($input: ConfirmWinemakingInput!) {
    confirmWinemaking(input: $input)
  }
`)

export const mutatioinResetConfirmationRequest = graphql(`
  mutation ResetConfirmationRequest($input: ResetConfirmationRequestInput!) {
    resetConfirmationRequest(input: $input)
  }
`)

export const mutateReplacementCertificateRequest = graphql(`
  mutation ReplacingCertificate($id: ID!) {
    replacementCertificateRequest(id: $id) {
      id
      status
      certificateType
      commodity
      destination {
        id
      }
      replacedBy {
        id
        requestName
        status
      }
    }
  }
`)

export const mutateRequestReplacementRequest = graphql(`
  mutation requestApprovalToReplaceExportCertificateRequest(
    $input: ApprovalToReplaceExportCertificateRequestInput!
  ) {
    requestApprovalToReplaceExportCertificateRequest(input: $input)
  }
`)

export const saveTransferRequestMutation = graphql(`
  mutation saveTransferRequestMutation($input: CoreTransferRequestInput!) {
    saveTransferRequest(input: $input) {
      id
      version
      status {
        code
        label
      }
      certificateNumber
      products {
        id
      }
    }
  }
`)

export const adjustBatchVolumeRequest = graphql(`
  mutation adjustBatchVolume(
    $productId: ID!
    $litres: Float!
    $reason: String!
  ) {
    adjustBatchVolume(
      input: {
        productId: $productId
        volumeAdjustment: { litres: $litres, reason: $reason }
      }
    ) {
      volumeAdjustment {
        date
        changeType
        litres
        reason
      }
    }
  }
`)
export const raiseTransferRequest = graphql(`
  mutation RaiseTransferRequest($id: ID!, $version: Int, $validation: Boolean) {
    raiseTransferRequest(
      input: { requestID: $id, version: $version, validationOnly: $validation }
    ) {
      certificateNumber
      id
      status
      submittedAt
    }
  }
`)

export const raiseExportRequest = graphql(`
  mutation RaiseExportRequest($id: ID!, $version: Int, $validation: Boolean) {
    raiseExportRequest(
      input: { requestID: $id, version: $version, validationOnly: $validation }
    ) {
      certificateNumber
      id
      status
      submittedAt
    }
  }
`)

// export const adjustBatchVolumeRequest = graphql(`
//   mutation AdjustBatchVolumeMutation(
//     $productId: ID!
//     $litres: String!
//     $reason: String
//   ) {
//     adjustBatchVolume(
//       input: {
//         productId: $productId
//         volumeAdjustment: { litres: $litres, reason: $reason }
//       }
//     ) {
//       volumeAdjustment {
//         date
//         changeType
//         litres
//         reason
//       }
//     }
//   }
// `)

export const saveExportRequestMutation = graphql(`
  mutation saveExportRequestMutation($input: CoreExportRequestInput!) {
    saveExportRequest(input: $input) {
      id
      version
      status {
        label
      }
    }
  }
`)

export const ChangeTransferRequestStatusMutation = graphql(`
  mutation changeTransferRequestStatusMutation(
    $input: ChangeTransferRequestStatusInput!
  ) {
    changeTransferRequestStatus(input: $input) {
      transferRequestId
      status
      version
    }
  }
`)
export const ChangeExportRequestStatusMutation = graphql(`
  mutation changeExportRequestStatusMutation(
    $input: ChangeExportRequestStatusInput!
  ) {
    changeExportRequestStatus(input: $input) {
      exportRequestId
      status
      version
    }
  }
`)

export const deleteReplacementExportRequestMutation = graphql(`
  mutation deleteReplacementExportRequest(
    $input: DeleteReplacementExportRequestInput!
  ) {
    deleteReplacementExportRequest(input: $input) {
      parentId
    }
  }
`)
export const downloadExportRequestsAsCsvMutation = graphql(`
  mutation downloadExportRequestsAsCsv(
    $input: DownloadExportRequestsCsvInput!
  ) {
    downloadExportRequestsAsCsv(input: $input) {
      filename
      presignedUrl
    }
  }
`)

export const updatePrintReasonMutation = graphql(`
  mutation updatePrintReason($input: UpdatePrintReasonInput!) {
    updatePrintReason(input: $input) {
      outputEventId
      exportRequestOutputId
      reasonForReprinting
      createdAt
    }
  }
`)

export const updateApprovedTransferTransportMutation = graphql(`
  mutation updateApprovedTransferTransport(
    $input: UpdateApprovedTransferTransportInput!
  ) {
    updateApprovedTransferTransport(input: $input)
  }
`)

export const generateExportPdfMutation = graphql(`
  mutation generateExportPdf($input: PrintCertificateInput!) {
    printCertificate(input: $input) {
      executionArn
      exportRequestId
      pdfCertificateUrl
      exportRequestOutputId
    }
  }
`)

export const createSupportingDocumentMutation = graphql(`
  mutation createSupportingDocument($input: CoreSupportingDocumentInput!) {
    createSupportingDocument(input: $input) {
      id
      comment
      documentNumber
      documentReferenceNumber
      primaryOperator {
        id
        name
      }
      intendedOperators {
        id
        name
      }
      originCountry {
        id
        name
      }
      productDescription
      identificationMarks
      foreignManufacturePremises
      foreignPremisesId
      nzManufacturePremises
      productionDates {
        from
        to
      }
    }
  }
`)

export const cancelSupportingDocumentMutation = graphql(`
  mutation CancelSupportingDocument($input: CancelSupportingDocumentInput!) {
    cancelSupportingDocument(input: $input) {
      success
      message
      supportingDocument {
        id
        status
      }
    }
  }
`)

export const updateSupportingDocumentMutation = graphql(`
  mutation UpdateSupportingDocument($input: UpdateSupportingDocumentInput!) {
    updateSupportingDocument(input: $input) {
      success
      message
      supportingDocument {
        id
        status
        documentNumber
        documentReferenceNumber
        primaryOperator {
          id
          name
        }
        intendedOperators {
          id
          name
        }
        productDescription
        identificationMarks
        foreignManufacturePremises
        foreignPremisesId
        nzManufacturePremises
        productionDates {
          from
          to
        }
        originCountry {
          id
          name
        }
      }
    }
  }
`)

export const extendIntendedOperatorMutation = graphql(`
  mutation ExtendIntendedOperator($input: ExtendIntendedOperatorInput!) {
    extendIntendedOperator(input: $input) {
      success
      message
      supportingDocument {
        id
        status
        intendedOperators {
          id
          name
        }
      }
    }
  }
`)
